import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function EditProfile() {
  const [username, setUsername] = useState("");
  const [bio, setBio] = useState("");
  const [loading, setLoading] = useState(true);

  // Simulate fetching user profile
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setUsername("demoUser");
      setBio("Hi! I'm a demo user and this is my static bio.");
      setLoading(false);
    }, 800); // fake loading
  }, []);

  const handleUpdate = (e) => {
    e.preventDefault();
    alert("Profile updated (but not really — demo only)");
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-600 text-lg">Loading...</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-white">
      <div className="w-1/4 border-r px-6 py-8">
        <div className="flex flex-col space-y-4 font-medium text-black">
          <Link
            to="/edit-profile"
            className="text-purple-700 border-l-4 border-purple-700 pl-2"
          >
            Edit Profile
          </Link>
          <Link
            to="/edit-account"
            className="hover:text-purple-700 hover:pl-2 transition-all"
          >
            Edit Account
          </Link>
          <button
            onClick={() => {
              alert("Simulated logout (no token used)");
            }}
            className="text-left text-black hover:text-purple-700 hover:pl-2 transition-all"
          >
            Log out
          </button>
        </div>
      </div>

      <div className="flex-1 px-10 py-8">
        <h1 className="text-3xl font-semibold mb-6">Edit Profile</h1>

        <form onSubmit={handleUpdate} className="space-y-6 max-w-lg">
          <div>
            <label className="block font-medium mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full border rounded px-4 py-2"
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Bio</label>
            <textarea
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              rows="4"
              className="w-full border rounded px-4 py-2"
              placeholder="Tell others a little bit about yourself"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded font-semibold"
          >
            Update
          </button>
        </form>
      </div>
    </div>
  );
}